<app-page-header
    title="Configuración de Procesos"
    mobileTitle="Procesos"
    icon="fas fa-cogs"
    optionsLabel="Opciones"
    optionsIcon="fa fa-cog"
    [hasOptions]="!showMobileDetail"
    [showBack]="showMobileDetail"
    [unifiedOnMobile]="showMobileDetail"
    (back)="closeDetail()">
    <div headerOptions>
        @if (perm.canCurrent('canCreate')) {
        <a class="dropdown-item" (click)="newProcessModal()">
            <i class="fas fa-plus fa-fw me-2 text-primary"></i> Nuevo proceso
        </a>
        }
    </div>
</app-page-header>

@if (!showMobileDetail) {
<div class="row">
    <div class="col-12" [class.col-md-12]="!appSettings.isMobile()"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            <app-process-list (selectEvent)="onProcessSelected($event)">
                @if (perm.canCurrent('canCreate')) {
                <button class="btn btn-primary btn-sm" (click)="newProcessModal()">
                    <i class="fas fa-plus"></i> Nuevo Proceso
                </button>
                }
            </app-process-list>
        </div>
    </div>
</div>
} @else {
<div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nuevo proceso' : 'Editar proceso' }}</h5>
    <app-process-form [processForm]="processForm" [mode]="mode()"></app-process-form>
</div>
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="processForm.invalid"
        (click)="saveProcess()">
        Guardar
    </button>
</app-mobile-footer>
}

<ng-template #processModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">{{ mode() === formMode.CREATE ? 'Nuevo' : 'Editar' }} Proceso</h4>
    </div>
    <div class="modal-body">
        <app-process-form [processForm]="processForm" [mode]="mode()"></app-process-form>
    </div>
    <div class="modal-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="saveProcess()" [disabled]="processForm.invalid">
            Guardar
        </button>
    </div>
</ng-template>
